/**
 * Focal disables PDP click-nav arrows on video/model slides so the player stays clickable.
 * That also hides the side-arrow cursor, so shoppers cannot click through to the next media.
 * Keep arrows on video/external_video; skip only 3D models and real controls (play, links, control bar).
 */
(function productMediaClickNav() {
  if (window.__productMediaClickNavPatched) return;
  window.__productMediaClickNavPatched = true;

  var INTERACTIVE_SELECTOR =
    'button, a, input, textarea, select, .video-wrapper__play-button, .video-wrapper__poster-content, .product__zoom-button, .pswp__button';

  function isPhone() {
    try {
      return window.matchMedia(window.themeVariables.breakpoints.phone).matches;
    } catch (e) {
      return false;
    }
  }

  function isModel(el) {
    return el && el.getAttribute && el.getAttribute('data-media-type') === 'model';
  }

  function isInteractiveTarget(event) {
    var target = event && event.target;
    if (!target || !target.closest) return false;
    if (target.closest(INTERACTIVE_SELECTOR)) return true;

    var video = target.closest('video');
    if (!video) return false;

    var pointY = event.clientY;
    if (pointY == null && event.changedTouches && event.changedTouches[0]) {
      pointY = event.changedTouches[0].clientY;
    }
    if (pointY == null) return false;

    return pointY > video.getBoundingClientRect().bottom - 48;
  }

  function patchPrototype(Ctor) {
    Ctor.prototype._onStaticClick = async function _onStaticClick(event, pointer, cellElement) {
      var flickity = await this.flickityInstance;
      if (!cellElement || isPhone()) return;
      if (isModel(flickity.selectedElement) || isInteractiveTarget(event)) return;

      var bounds = flickity.viewport.getBoundingClientRect();
      var midpoint = Math.floor(bounds.right - bounds.width / 2);
      var clientX = pointer && pointer.clientX != null ? pointer.clientX : event.clientX;
      if (clientX > midpoint) {
        flickity.next();
      } else {
        flickity.previous();
      }
    };

    Ctor.prototype._onMouseMove = async function _onMouseMove(event) {
      var flickity = await this.flickityInstance;
      var hideArrows = isModel(flickity.selectedElement) || isInteractiveTarget(event);
      var bounds = this.getBoundingClientRect();
      var isRight = event.clientX > bounds.left + bounds.width / 2;
      this.classList.toggle('is-hovering-right', isRight && !hideArrows);
      this.classList.toggle('is-hovering-left', !isRight && !hideArrows);
    };
  }

  function rebindInstance(el) {
    if (!el || !el.hasAttribute('click-nav')) return;

    var start = async function () {
      var flickity = await el.flickityInstance;
      var previousStatic = el._onStaticClickBinded;
      var previousMove = el._onMouseMoveBinded;
      var nextStatic = el._onStaticClick.bind(el);
      var nextMove = el._onMouseMove.bind(el);

      el._onStaticClickBinded = nextStatic;
      el._onMouseMoveBinded = nextMove;

      if (previousMove) el.removeEventListener('mousemove', previousMove);
      el.addEventListener('mousemove', nextMove);

      if (!flickity || typeof flickity.on !== 'function') return;
      if (previousStatic) flickity.off('staticClick', previousStatic);
      flickity.off('staticClick', nextStatic);
      flickity.on('staticClick', nextStatic);
    };

    if (el.dataset.clickNavPatched !== 'true') {
      el.dataset.clickNavPatched = 'true';
      el.addEventListener('flickity:ready', start, { once: true });
    }
    if (el.classList.contains('flickity-enabled')) start();
  }

  function applyToDocument() {
    document.querySelectorAll('flickity-carousel[click-nav]').forEach(rebindInstance);
  }

  function apply() {
    var Ctor = customElements.get('flickity-carousel');
    if (!Ctor || typeof Ctor.prototype._onStaticClick !== 'function') return false;
    patchPrototype(Ctor);
    applyToDocument();
    return true;
  }

  function boot() {
    if (apply()) {
      document.addEventListener('shopify:section:load', applyToDocument);
      return;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('flickity-carousel').then(function () {
        apply();
        document.addEventListener('shopify:section:load', applyToDocument);
      });
    }
  }

  boot();
})();
